import { Outlet, useLocation } from 'react-router-dom';
import { useRoles } from '../../hooks/useRole';
import { useRoleContext } from '../../hooks/useRoleContext';
import React from 'react';
import LoadingComponent from '@/components/LoadingComponent';
import assets from '../../const/assets';
// ... existing code ...
const Admin = () => {
  const { data: roles } = useRoles();
  const { setRoles } = useRoleContext();
  const pathname = useLocation();

  React.useEffect(() => {
    if (roles) {
      setRoles(roles);
    }
  }, [roles, setRoles]);

  if (!roles) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingComponent />
      </div>
    );
  }
  return (
    <>
      {pathname.pathname === '/admin' && (
        <div className="flex justify-center items-center h-screen text-2xl font-bold text-center relative">
          <img
            src={assets.imageBg}
            alt="logo"
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
          <div className="relative z-10 backdrop-blur-md bg-white/10 p-12 rounded-2xl shadow-2xl border border-white/20 hover:shadow-[0_0_30px_rgba(255,255,255,0.3)] transition-all duration-300">
            <h1 className="text-5xl font-bold tracking-wider text-white drop-shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <span className="bg-gradient-to-r from-luxury-200 via-luxury-300 to-luxury-400 bg-clip-text text-transparent animate-gradient drop-shadow-[0_2px_2px_rgba(0,0,0,0.3)] text-6xl font-bold">
                Chào mừng bạn đến với hệ thống quản lý
              </span>
              <br />
              <span className="bg-gradient-to-r from-luxury-300 via-luxury-400 to-luxury-500 bg-clip-text text-transparent animate-gradient mt-8 block text-8xl font-black tracking-widest hover:scale-110 transition-all duration-500 drop-shadow-[0_8px_8px_rgba(0,0,0,0.5)] luxury-gradient-horizontal relative">
                <span className="absolute inset-0 bg-gradient-to-r from-luxury-200/20 via-luxury-300/20 to-luxury-400/20 blur-xl -z-10"></span>
                AI DAY CRM
              </span>
            </h1>
          </div>
        </div>
      )}
      <Outlet />
    </>
  );
};

export default Admin;
